export default {
  methods: {
    scrollToFirstError() {
      const firstElement = document.getElementsByClassName('error--text')[0]

      if (firstElement) {
        const domRect = firstElement.getBoundingClientRect()

        window.scrollTo(
          domRect.left + document.documentElement.scrollLeft,
          domRect.top + document.documentElement.scrollTop
        )
      }
    }
  }
}
